import React, { useState } from "react";
import {
  Box,
  InputBase,
  makeStyles,
  Typography,
  MenuItem,
  Select,
  FormControl,
  NativeSelect,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  inputWithLabelContainer: {
    marginBottom: "2.4rem",
  },

  inputContainer: {
    display: "flex",
    alignItems: "center",

    background: "#FFFFFF",
    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  input: {
    height: (props) => (props.height ? props.height : 40),
    padding: "8px 1.2rem",

    display: "flex",
    alignItems: "flex-start",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    fontWeight: "400",

    width: (props) => (props.width ? `${props.width / 10}rem` : "100%"),
  },

  input2: {
    height: (props) => (props.height ? props.height : 40),
    padding: "8px 1.2rem",

    display: "flex",
    alignItems: "flex-start",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    fontWeight: "400",
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    width: (props) => (props.width2 ? `${props.width2 / 10}rem` : "100%"),
    marginLeft: "8px",
  },
  label: {
    marginBottom: "1.2rem",
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.1rem",
  },
  inputRightText: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    marginLeft: "8px",
  },

  buttonExtra: {
    marginLeft: "2rem",
  },

  pairsSelect: {
    // width: "fit-content",

    background:
      theme.palette.type === "dark"
        ? "linear-gradient(264.59deg, #262C47 -9.52%, rgba(38, 44, 71, 0) 112.5%)"
        : " linear-gradient(84.55deg, #FFFFFF -57.11%, rgba(255, 255, 255, 0.5) 158.73%)",
    border: "none",

    color: theme.palette.type === "dark" ? "#fff" : "#192039",

    display: "flex",
    borderRight: "1px solid #ccc",
    paddingRight: "1.2rem",
    paddingLeft: "1.2rem",
    fontWeight: "500",
    fontSize: "1.2rem",
    lineHeight: "2.4rem",
  },

  selectRoot: {
    background: "red",
  },
  pairMenuItem: {
    // background: theme.palette.type === "dark" ? "#192039" : "#fff",
    // color: theme.palette.type === "dark" ? "#fff" : "#192039",
    fontWeight: "500",
    fontSize: "1.2rem",
    lineHeight: "2.4rem",
  },

  selectInput: {
    background: "red",
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontSize: "1.2rem",
    margin: "1.5rem 0 0 1rem",
  },
}));

const InputWithDropdown = ({
  label,
  placeholder,
  placeholder2,
  value,
  value2,
  setValue,
  setValue2,
  height,
  width,
  width2,
  rightText,
  type,
  Button,
  Entered,
  options,
  handleChange,
  selectValue,
  withdrawValue,
}) => {
  const classes = useStyles({ height, width, width2 });

  const [age, setAge] = useState(10);

  console.log("AGE FOR SELECT", selectValue);
  console.log("AGE VALUE FOR INPUT", value);
  console.log("AGE with options", options[0]);

  // const handleChange = (event) => {
  //   console.log("opt", event.target.value);
  //   setAge(event.target.value);
  // };

  return (
    <Box className={classes.inputWithLabelContainer}>
      {Entered && <Entered />}
      <Box className={classes.inputContainer}>
        <NativeSelect
          value={selectValue}
          onChange={(e) => handleChange(e.target.value)}
          className={classes.selectEmpty}
          classes={{ nativeInput: classes.selectInput }}
        >
          <option value="select">None</option>
          {options.map((opt) => {
            // console.log({ opt });
            return (
              <option
                className={classes.pairMenuItem}
                value={opt.id ? opt.id : opt}
                id={opt.id}
              >
                {opt.id ? opt.name : opt}
              </option>
            );
          })}
        </NativeSelect>
        {/* <FormControl className={classes.formControl}>
          <NativeSelect
            value={withdrawValue}
            onChange={(e) => handleChange(e.target.value)}
            // className={classes.pairsSelect}
            classes={{ nativeInput: classes.selectInput }}
            className={classes.selectEmpty}
            // inputProps={{ "aria-label": "age" }}
          >
            {options.map((opt) => {
              return (
                <option
                  className={classes.pairMenuItem}
                  value={opt.id ? opt.id : opt}
                  selected
                >
                  {opt.id ? opt.name : opt}
                </option>
              );
            })}
          </NativeSelect>
       
        </FormControl> */}

        <InputBase
          className={classes.input}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          multiline={height}
          type={type}
        />
        {rightText && (
          <Typography className={classes.inputRightText}>
            {rightText}
          </Typography>
        )}
        {placeholder2 && (
          <InputBase
            className={classes.input2}
            value={value2}
            onChange={(e) => setValue2(e.target.value)}
            placeholder={placeholder2}
            multiline={height}
            type={type}
            step="100"
          />
        )}
        {Button && (
          <Box className={classes.buttonExtra}>
            <Button />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default InputWithDropdown;
